const tpl = (name) => `NDFL3_PROPERTY_INCOME/${name}`;

export const INITIALIZE = tpl`INITIALIZE`;

export const SUBMIT = tpl`SUBMIT`;
export const SUBMIT_SUCCESS = tpl`SUBMIT_SUCCESS`;
export const SUBMIT_FAILURE = tpl`SUBMIT_FAILURE`;

export const PROPERTY_OBJECTS = tpl`PROPERTY_OBJECTS`;
export const PROPERTY_OBJECTS_SUCCESS = tpl`PROPERTY_OBJECTS_SUCCESS`;
export const PROPERTY_OBJECTS_FAILURE = tpl`PROPERTY_OBJECTS_FAILURE`;
